import {
    BackButton,
    Divider,
    Form,
    FormDropDown,
    FormInput,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingGarage = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_Garage.garage' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_Garage.garageDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_Garage.type' />}
                    value={props.garage?.type}
                    references={props.reference.references?.GarageType}
                    referencesEvent={() => props.reference.doGetReferences('GarageType')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}type`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Dwellings_Garage.numberOfCars' />}
                    value={props.garage?.numberOfVehicles}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({ code: `${props.dotProp}numberOfVehicles`, value })
                    }
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingGarage;
